import React from 'react';
import { StyledHeading } from './styles';
import Chart from 'react-apexcharts';

const LineChart = ({ series, categories, colors, title, description, height, width, children }) => {
  const chartData = {
    series: series,
    options: {
      colors: colors,
      chart: {
        toolbar: {
          show: false,
        },
        type: 'line',
        zoom: {
          enabled: false,
        },
        fontFamily: 'Open Sans, sans-serif',
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800,
          animateGradually: {
            enabled: true,
            delay: 150,
          },
          dynamicAnimation: {
            enabled: true,
            speed: 350,
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      grid: {
        row: {
          colors: ['transparent'],
          opacity: 0.5,
        },
      },
      xaxis: {
        type: 'category',
        categories: categories,
        labels: {
          show: true,
        },
      },
    },
  };

  return (
    <StyledHeading>
      <h2>{title}</h2>
      <p>{description}</p>
      {children}
      <Chart options={chartData.options} series={chartData.series} height={height} width={width} />
    </StyledHeading>
  );
};

export default LineChart;
